// extracted by mini-css-extract-plugin
export default {"error":"InputError_error"};